import styled from 'styled-components';

export const Page = styled.div`
  padding: 5px;
  height: 100%;
  padding-bottom: 100px;
`;

export const Titulo = styled.h2`
  color: var(--primary-color-sefaz);
  margin: 0px;
  margin-top: 40px;
  font-weight: 600;
  font-size: 20pt;
`;

export const Descricao = styled.div`
  margin: 0px;
  margin-bottom: 10px;
  text-align: justify;
  ul {
    list-style-type: square;
    margin-left: 20px;
  }
`;

export const Imagem = styled.img`
  width: 200%;
  padding: 10px;
  margin: auto;
  @media (max-width: 1486px) {
    width: 150%;
  }
  @media (max-width: 1094px) {
    width: 125%;
  }
  @media (max-width: 994px) {
    width: 100%;
  }
  @media (max-width: 870px) {
    width: 150%;
  }
`;
